import { colors } from "@mui/material";
import getProjectConfig from "./projectConfigs";

const projectConfig = getProjectConfig();

const colorConfigs = {
  sidebar: {
    bg: projectConfig?.theme?.mainColor,
    color: projectConfig?.theme?.sidebar?.color,
    hoverBg: projectConfig?.theme?.hoverBg,
    meduimColor: projectConfig?.theme?.meduimColor,
    ligthBg: projectConfig?.theme?.ligthMain
  },
  mainBg: colors.grey["100"],
  grayText: "#727272",
  excelJS: projectConfig?.theme?.excelJS,
};

export default colorConfigs;